import React, { memo } from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import {
  isDayClosed,
  openingClosingHours
} from '../../../../shared/utils/store/store';

import './store-hours.scss';

function StoreHours(props) {
  const { selectedDate, weekDays } = props;

  return (
    <ol className="store-hours">
      {Array.isArray(weekDays) &&
        selectedDate &&
        weekDays.map((day, idx) => {
          const selectedDayOfWeek = format(
            selectedDate || '',
            'dddd'
          ).toUpperCase();
          const dayOfWeek = format(day?.formattedDate || '', 'dddd');
          const date = format(day?.formattedDate || '', 'M/D');
          const isClosed = isDayClosed(day);
          let styleName = isClosed ? 'closed-day' : 'day';

          if (selectedDayOfWeek === dayOfWeek.toUpperCase() && isClosed) {
            styleName = 'selected-closed-day';
          } else if (selectedDayOfWeek === dayOfWeek.toUpperCase()) {
            styleName = 'selected-day';
          }

          return (
            <li key={`wd-${idx}`} styleName={styleName}>
              <span styleName="day-of-week">{dayOfWeek}</span>
              <span styleName="date">{date}</span>
              {isClosed ? (
                <span styleName="week-hours">CLOSED</span>
              ) : (
                <span styleName="week-hours">{openingClosingHours(day)}</span>
              )}
            </li>
          );
        })}
    </ol>
  );
}

StoreHours.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  weekDays: PropTypes.arrayOf(
    PropTypes.shape({
      closingTime: PropTypes.shape({
        formattedHour: PropTypes.string,
        hour: PropTypes.number,
        minute: PropTypes.number
      }),
      formattedDate: PropTypes.string,
      openingTime: PropTypes.shape({
        formattedHour: PropTypes.string,
        hour: PropTypes.number,
        minute: PropTypes.number
      })
    })
  )
};

export default memo(StoreHours);
